<template>
	<div class="custom-models">
    <multiselect
        placeholder="Search your models"
        :reset-after="true"
        :loading="isLoading"
        :disabled="!enabled"
        :show-labels="false"
        :internal-search="false"
        :show-no-results="false"
        :options="searchResults"
        @select="selectModel"
        @search-change="modelSearch"
        @open="modelSearch(null)">

			<template slot="caret"></template>

			<template slot="option" scope="prop">
				<img class="option__image" :src="prop.option.preview_square">
				<span>{{prop.option.name}}</span>
			</template>
		</multiselect>

		<model-tiles :enabled="enabled" :models="models" :small="true" :removable="true"></model-tiles>
	</div>
</template>
<script>
	import axios from 'axios'

	import { Multiselect } from 'vue-multiselect'
	import ModelTiles from './ModelTiles'
	export default {
		name: 'CustomModels',
		components: {
			Multiselect,
			ModelTiles
		},
		props: {
			value: Array,
			enabled: {
				default: true,
				type: Boolean
			},
			limit: {
				default: 6,
				type: Number
			}
		},
		data () {
			return {
				isLoading: false,
				searchResults: []
			};
		},
		computed: {
			models () {
				return this.value;
			},
			placeholders () {
				return new Array(this.limit - this.models.length);
			},
		},
		methods: {
			selectModel (selected) {
				if (this.value.length < this.limit) {
					this.value.push(selected);
				}
			},
      updateResults (resp) {
        this.isLoading = false;
        const excludedIds = this.models.map(model => model.id);
        this.searchResults = resp.data.filter(model => !excludedIds.includes(model.id));
      },
			modelSearch (query) {
				if (this.isLoading) return;

				this.isLoading = true;
				let options = { params: { query: query } };

				axios.get('/profile/models/search', options)
					.then(this.updateResults);
			},
		}
	}
</script>